// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"498":"810013fd","598":"4e9bd8fe","703":"73bdfc33","787":"e7fe3ffd"}[chunkId] + ".chunk.js";
};